export default "__VITE_ASSET__0393e254__"